$(function() {
    initCollectionListSlider();
    onLoadUpdateNoteText();
    onLoadExpandNote();
});

onClickProductOption = (e,q) => {
    var e = $(e);
    var qty = parseInt(q);

    var changeQtyValue = e.closest('.product-blocks').find('form').find('.quantity-input input');
    var changeJSQtyValue = e.closest('.product-blocks').find('form').find('.product-form__quantity input');
    
    e.parent().parent().find('label').removeClass('active');
    e.addClass('active');

    changeQtyValue.val(qty);
    changeJSQtyValue.val(qty);
}

initCollectionListSlider = () => {
    $('.jsc-collection-list').flickity({
        cellAlign: 'left',
        pageDots: false,
        prevNextButtons: false,
        adaptiveHeight: true
    })
}

$(document).ready(function(){
    updateLinkHref = () => {
        var searchLink = $('#search-link');
        if ($(window).width() > 959) {
            searchLink.attr('href', '/search');
        }
    }

    updateLinkHref();

    $(window).resize(function() {
        updateLinkHref();
    });
});

// handle header display event
$(document).ready(function() {
    var header = $('#header');
    var headerHeight = header.outerHeight();
    var lastScrollTop = headerHeight;

    $(window).scroll(function(event) {
      var currentScroll = $(this).scrollTop();

      if (currentScroll > lastScrollTop) {
        header.addClass('hidden');
      } else {
        header.removeClass('hidden');
      }

      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    });

    $('#search-link').on('click', function(e) {
        e.preventDefault();
        if ($(window).width() <= 959) {
            $('html, body').animate({
                scrollTop: $("input[name='q']").offset().top,
            }, 2000);
        }
    });
});

// start: update cart note
updateCartNote = (e) => {
    var note = $(e).val();
    sessionStorage.setItem('cartNote', note);
}

onLoadUpdateNoteText = () => {
    var $cartNoteInput = $('textarea[name="note"]');
    var note = sessionStorage.getItem('cartNote');
    $cartNoteInput.text(note);

    if(window.location.href.includes('/cart')) {
        CartJS.setNote(note);
    }
}

checkoutUpdateNote = () => {
    var note = sessionStorage.getItem('cartNote');
    CartJS.setNote(note);
}

onLoadExpandNote = () => {
    var note = sessionStorage.getItem('cartNote');
    var $noteTrigger = $('[data-order-note-trigger]');
    if (note != null && note.length > 0) {
        $noteTrigger.click();
    }
}
// end: update cart note